export default __webpack_public_path__ + "static/media/nutri3.8c954836.jpeg";